import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var KeynoteSvg = function KeynoteSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0692F9",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.198 12.833c0-.46.359-.833.802-.833s.802.373.802.833v3.334h1.203c.222 0 .401.186.401.416s-.18.417-.4.417H9.994a.41.41 0 0 1-.401-.417c0-.23.18-.416.4-.416h1.204zM14.754 7c.282 0 .543.154.688.405l1.444 2.5a.85.85 0 0 1-.276 1.143.8.8 0 0 1-.412.119H7.802c-.443 0-.802-.373-.802-.834 0-.15.04-.299.114-.428l1.444-2.5A.8.8 0 0 1 9.246 7z",
    clipRule: "evenodd"
  }));
};
export var Keynote = function Keynote(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: KeynoteSvg
  }));
};